import { GasStationIcon } from './GasStationIcon';

/**
 * author: Google
 * id 50E30598-BCD8-4167-BDAC-FF6971E745D7
 * name gas-station
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gas-station.svg
 * tags
 * - Places 
 * - Automotive 
 */
export const PetrolPumpIcon = GasStationIcon;
export default PetrolPumpIcon